export const LogoMark = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M18 46 V18 L46 46 V18"
      stroke="#3DA5DD"
      strokeWidth="4"
      strokeLinecap="square"
    />
    <path
      d="M46 8 L48.2 12.8 L53 15 L48.2 17.2 L46 22 L43.8 17.2 L39 15 L43.8 12.8 Z"
      fill="#3DA5DD"
      transform="translate(4,2) scale(0.55)"
    />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <a href="/" data-testid="logo-link" className="flex items-center gap-3 group">
    <LogoMark size={compact ? 26 : 30} className="transition-transform duration-500 group-hover:rotate-90" />
    <span className="font-display text-xl tracking-wide text-pearl">
      North <span className="text-champagne italic">&amp;</span> Noble
    </span>
  </a>
);
